import { Flex, Link, List, Text } from "@wayflyer/flyui";
import { useIntl } from "react-intl";

import { MESSAGES } from "../message-definitions";
import { MonthsCoverageBar } from "../months-coverage-bar/months-coverage-bar";
import type { AggregateCoverage as AggregateCoverageData } from "../utils";

type AggregateCoverageProps = {
  coverage: AggregateCoverageData;
  onViewRequirements: () => void;
};

export const AggregateCoverage = ({ coverage, onViewRequirements }: AggregateCoverageProps) => {
  const intl = useIntl();
  const { body, months } = coverage;
  const requirementsLink = <Link onClick={onViewRequirements}>{intl.formatMessage(MESSAGES.viewRequirements)}</Link>;

  return (
    <Flex direction="column" gap="5" maxWidth="594px">
      {body.kind === "fragmentedList" ? (
        <Flex direction="column" gap="2">
          <Text size="sm">{body.intro}</Text>
          <List>
            {body.periods.map((period, index) => (
              <List.Item key={index}>
                <Text size="sm">{period}</Text>
              </List.Item>
            ))}
          </List>
          <Text size="sm">
            {body.outro} {requirementsLink}
          </Text>
        </Flex>
      ) : (
        <Text size="sm">
          {body.text} {requirementsLink}
        </Text>
      )}
      <MonthsCoverageBar months={months} />
    </Flex>
  );
};
